import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { EMPLOYEE_ROUTE } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, DELETE, PUT } = HTTP_METHODS;
const { GET_EMPLOYEE, GET_EMPLOYEE_ID_CARD } = EMPLOYEE_ROUTE;

export const employeeApi = createApi({
  reducerPath: 'employeeApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getEmployee: builder.query({
      query: (data) => ({ url: `${GET_EMPLOYEE}${buildQueryString(data)}`, method: GET })
    }),
    getEmployeeIdCard: builder.query({
      query: (id) => ({
        url: `${GET_EMPLOYEE_ID_CARD}/${id}`,
        method: 'GET',
        headers: {
          Accept: 'application/pdf'
        },
        responseHandler: async (response) => response.blob(), // ✅ Convert response to Blob
        cache: 'no-store' // Prevent caching issues
      }),
      transformResponse: (response) => response // ✅ Ensure it remains a Blob
    }),

    getEmployeeDropDown: builder.query({
      query: (data) => ({ url: `${GET_EMPLOYEE}${buildQueryString(data)}`, method: GET })
    }),
    getEmployeeById: builder.query({
      query: (id) => ({
        url: `${GET_EMPLOYEE}/${id}`,
        method: GET
      })
    }),
    addEmployee: builder.mutation({
      query: (data) => ({ url: `${GET_EMPLOYEE}`, method: POST, data })
    }),
    deleteEmployee: builder.mutation({
      query: (id) => ({
        url: `${GET_EMPLOYEE}/${id}`,
        method: DELETE
      })
    }),
    editEmployee: builder.mutation({
      query: (data) => ({
        url: `${GET_EMPLOYEE}/${data.id}`,
        method: PUT,
        data: data?.data
      })
    }),
    getEmployeeTree: builder.query({
      // eslint-disable-next-line no-unused-vars
      query: (userId) => ({
        url: `${GET_EMPLOYEE}/organization/org-tree`,
        method: 'GET'
      })
    })
  })
});

export const {
  useGetEmployeeIdCardQuery,
  useGetEmployeeQuery,
  useGetEmployeeDropDownQuery,
  useGetEmployeeByIdQuery,
  useLazyGetEmployeeByIdQuery,
  useAddEmployeeMutation,
  useDeleteEmployeeMutation,
  useEditEmployeeMutation,
  useGetEmployeeTreeQuery
} = employeeApi;
